import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  const handleStartTrial = () => {
    navigate('/register');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleWatchDemo = () => {
    // You can implement demo functionality here
    alert('Demo video will be available soon!');
  };

  return (
    <div className="main-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-content">
            <div className="logo-section">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              <span className="logo-text">ClickLooks</span>
              </div>
            </div>
            <div className="nav-buttons">
              <button className="btn-ghost" onClick={handleLogin}>Login</button>
              <button className="btn-premium btn-sm" onClick={handleStartTrial}>Start Free Trial</button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        {/* Background Image */}
        <div className="hero-bg">
          <div className="hero-image-placeholder">
            <div className="hero-image-overlay"></div>
          </div>
          <div className="hero-overlay"></div>
        </div>
        
        <div className="hero-content">
          <div className="hero-inner">
            <div className="badge">✨ #1 Salon Management Software</div>
            <h1 className="hero-title">
              Transform Your Salon
              <br />
              Into a Success Story
            </h1>
            <p className="hero-description">
              Streamline operations, delight customers, and grow your business with our all-in-one salon management platform. 
              Join thousands of successful salon owners worldwide.
            </p>
            <div className="hero-buttons">
              <button className="btn-premium btn-xl shadow-glow" onClick={handleStartTrial}>
                Start Your Free Trial
                <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="m9 18 6-6-6-6"/>
                </svg>
              </button>
              <button className="btn-outline btn-xl" onClick={handleWatchDemo}>Watch Demo</button>
            </div>
            <div className="hero-features">
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
                30-day free trial
              </div>
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
                No credit card required
              </div>
              <div className="feature-item">
                <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
                Setup in 5 minutes
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Everything You Need to Succeed</h2>
            <p className="section-description">
              Powerful features designed specifically for modern salon businesses
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <h3 className="feature-title">Smart Booking</h3>
              <p className="feature-description">Advanced appointment scheduling with real-time availability and automated reminders.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="m22 21-3-3"/>
                </svg>
              </div>
              <h3 className="feature-title">Client Management</h3>
              <p className="feature-description">Complete customer profiles with service history, preferences, and loyalty tracking.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/>
                </svg>
              </div>
              <h3 className="feature-title">Analytics & Reports</h3>
              <p className="feature-description">Detailed insights into your business performance, revenue tracking, and growth metrics.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              </div>
              <h3 className="feature-title">Service Management</h3>
              <p className="feature-description">Customize services, pricing, and packages with flexible booking options.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/>
                </svg>
              </div>
              <h3 className="feature-title">Staff Management</h3>
              <p className="feature-description">Manage stylists, track performance, and optimize scheduling for maximum efficiency.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="m9 12 2 2 4-4"/>
                  <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"/>
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
                </svg>
              </div>
              <h3 className="feature-title">Marketing Tools</h3>
              <p className="feature-description">Built-in email marketing and customer retention tools.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">10,000+</div>
              <p className="stat-label">Active Salons</p>
            </div>
            <div className="stat-item">
              <div className="stat-number">2M+</div>
              <p className="stat-label">Appointments Booked</p>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <p className="stat-label">Customer Satisfaction</p>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <p className="stat-label">Support Available</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Ready to Transform Your Salon Business?</h2>
          <p className="cta-description">
            Join thousands of successful salon owners who trust ClickLooks to manage their business.
          </p>
          <div className="cta-buttons">
            <button className="btn-secondary btn-xl" onClick={handleStartTrial}>
              Start Free Trial
              <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="m9 18 6-6-6-6"/>
              </svg>
            </button>
            <button className="btn-outline-white btn-xl">Contact Sales</button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <div className="logo-icon">
                <svg className="scissors-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="6" cy="6" r="3"/>
                  <path d="m21.5 21.5-5-5"/>
                  <path d="m12 12-5-5"/>
                  <path d="m9 9 5 5"/>
                  <circle cx="6" cy="18" r="3"/>
                  <path d="m21.5 2.5-5 5"/>
                </svg>
              </div>
              <span className="logo-text">ClickLooks</span>
            </div>
            <div className="footer-links">
              <a href="#" className="footer-link">Privacy</a>
              <a href="#" className="footer-link">Terms</a>
              <a href="#" className="footer-link">Support</a>
              <a href="#" className="footer-link">Contact</a>
            </div>
          </div>
          <div className="footer-bottom">
            © 2024 ClickLooks. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
